import React, { Component } from "react";
import styles from "../Calculator.scss";

export default class ComparisonChart extends Component {
  render() {
    return (
      <span className={styles.tableContainer}>
        {/*<h3> Kingston vs {this.props.cityName} ($/Year)</h3>*/}
          <table>
            <tbody>
              <tr>
                <th>{this.props.title}</th>
                <th>Kingston</th>
                <th>{this.props.cityName}</th>
              </tr>

              {
                this.props.data.map((value, i)=> {
                  return (
                    <tr key={i}>
                      <td>{value}</td>
                      <td>${Math.round(this.props.kingstonData[i]).toLocaleString()}</td>
                      <td>${Math.round(this.props.cityData[i]).toLocaleString()}</td>
                    </tr>
                  )
                })
              }

            </tbody>
          </table>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Calculator/sections/ComparisonChart.js